import { Alert } from '@mui/material'
import React from 'react'

export function ViewOnlyAlert() {
  return (
    <Alert severity="info">
      These values are view-only. To edit, please revoke and add a new
      integration.
    </Alert>
  )
}
